module.exports = __webpack_public_path__ + "img/Character_Kamisato_Ayaka_Thumb.fe99bcde.png";